export default function FAQ({ faqs, testPrefix = 'faq' }) {
    return (
        <div className="divide-y divide-peri-200 overflow-hidden rounded-3xl border border-peri-200 bg-white">
            {faqs.map((f, i) => (
                <details key={i} className="group" data-testid={`${testPrefix}-${i}`}>
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-6 py-5 text-left font-semibold text-ink transition-colors hover:text-gold-700 [&::-webkit-details-marker]:hidden">
                        {f.q || f.question}
                        <span className="shrink-0 text-gold-700 transition-transform duration-300 group-open:rotate-45">
                            <svg className="h-4 w-4" viewBox="0 0 16 16" fill="none"><path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" /></svg>
                        </span>
                    </summary>
                    <p className="px-6 pb-6 text-[15px] leading-relaxed text-ink-muted">{f.a || f.answer}</p>
                </details>
            ))}
        </div>
    );
}
